import React, { useRef } from "react";
import styled from "styled-components";

const StyledInput = styled.input`
  width: 80%;
  max-width: 9rem;
  border-radius: 5px;
  flex-grow: 2;
  color: #3c3c3c;
  font-size: 1rem;
  background-color: #00000028;
  margin: 0.25rem;
  padding: 0.5rem;
`;

export const EditableInput = ({ amount, notify }) => {
  const inputRef = useRef(null);

  return (
    <StyledInput
      ref={inputRef}
      value={amount}
      onChange={(e) => {
        const newValue = Number.parseInt(e.target.value);
        if (Number.isSafeInteger(newValue)) {
          notify(newValue);
        } else if (e.target.value.length <= 1) {
          notify(0);
        }
      }}
    />
  );
};
